import { useEffect, useState } from 'react'

interface FloatingHeart {
  id: number
  left: number
  animationDuration: number
  animationDelay: number
  size: number
  emoji: string
}

const heartEmojis = ['❤️', '💕', '💖', '💗', '💘', '💝', '🩷', '🤍']

export default function FloatingHearts() {
  const [hearts, setHearts] = useState<FloatingHeart[]>([])

  useEffect(() => {
    const initialHearts: FloatingHeart[] = Array.from({ length: 15 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      animationDuration: 12 + Math.random() * 15,
      // First 5 hearts start immediately, rest have small delays (0-3 seconds)
      animationDelay: i < 5 ? 0 : Math.random() * 3,
      size: 20 + Math.random() * 20,
      emoji: heartEmojis[Math.floor(Math.random() * heartEmojis.length)],
    }))
    setHearts(initialHearts)
  }, [])

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      {hearts.map((heart) => (
        <span
          key={heart.id}
          className="floating-heart"
          style={{
            left: `${heart.left}%`,
            animationDuration: `${heart.animationDuration}s`,
            animationDelay: `${heart.animationDelay}s`,
            fontSize: `${heart.size}px`,
            opacity: 0.7,
          }}
        >
          {heart.emoji}
        </span>
      ))}
    </div>
  )
}
